export default "__VITE_ASSET__1d7bc950__"